module.exports = __webpack_public_path__ + "img/20200116155719288.d14e5e7b.jpg";